export function makePageNewBackgroundColor() {
  const styleTag = document.createElement('style');
  styleTag.textContent = `
    [ui-view="subheader"] {
      background-color: var(--uds-color-main-background);
    }

    upd-mover-app [ui-view="footer"] {
      background-color: transparent;
    }

    body {
      background-color: var(--uds-color-main-background);
    }
  `;

  document.head.appendChild(styleTag);

  return () => {
    styleTag.remove();
  };
}
